<form [formGroup]="form">
  <!-- ... nested form controls ... -->
  <h5 style="text-align: left" *ngIf="create">
    {{ "addLP.secondStep.title" | translate }}
  </h5>
  <div *ngIf="!franchise">
    <div style="display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;">
      <div>
        <label class="label"> {{ "addLP.secondStep.logo" | translate }} *</label>
        <input
          class="form-control"
          type="file"
          aria-label="file example"
          accept="image/x-png,image/gif,image/jpeg"
          (change)="onFileSelected($event)"
        />
      </div>

      <img
        *ngIf="uploadedFile else noImg"
        [src]="showlogo()"
        class="m-r-10"
        style="padding-left: 1rem"
        width="90px"
        height="90px"
        style="margin-right: 20px;"
      />
      <ng-template #noImg>
        <div style="
          width: 90px; 
          height: 90px;
          border: 2px solid #D9D9D9;
        ">
        </div>
      </ng-template>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.secondStep.companyName" | translate }} *</label
    >
    <div class="input-group">
      <input
        formControlName="companyName"
        class="form-control"
        type="text"
        required
        [placeholder]="'addLP.secondStep.companyName' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('companyName')?.valid && form.get('companyName')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('companyName')?.valid && form.get('companyName')?.touched
        "
      >
        {{ "validation.companyName" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.secondStep.companyAddress" | translate }} *</label
    >
    <div class="input-group">
      <input
        formControlName="companyAddress"
        class="form-control"
        type="text"
        required
        [placeholder]="'addLP.secondStep.companyAddress' | translate"
        [ngClass]="{
          'is-invalid':
            !form.get('companyAddress')?.valid &&
            form.get('companyAddress')?.touched
        }"
      />
      <div
        class="invalid-feedback"
        *ngIf="
          !form.get('companyAddress')?.valid &&
          form.get('companyAddress')?.touched
        "
      >
        {{ "validation.companyAddress" | translate }}
      </div>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.secondStep.companyActivity" | translate }} *</label
    >
    <div class="input-group">
      <select
        class="form-select form-control"
        formControlName="companyActivity"
      >
        <option selected disabled [ngValue]="null">
          {{ "addLP.secondStep.placeholderActivity" | translate }}
        </option>
        <option
          class="form-select"
          *ngFor="let companyActivity of companyActivity"
          [value]="companyActivity.hashed_id"
        >
          {{ companyActivity.title }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.thirdStep.category" | translate }} *</label
    >
    <div class="input-group">
      <select
        class="form-select form-control"
        formControlName="category"
        (change)="onChangeCategory()"
      >
        <option [ngValue]="null" disabled selected>
          {{ "addLP.thirdStep.selectCategory" | translate }}
        </option>
        <option
          *ngFor="let item of allCategoryNames$ | async"
          [ngValue]="item"
        >
          {{ item }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group">
    <label class="label"
      >{{ "addLP.thirdStep.subCategories" | translate }} *</label
    >
    <ng-select
      formControlName="subCategories"
      [items]="subCategoriesByCategory$ | async"
      bindLabel="subCategories"
      bindValue="id"
      [multiple]="true"
      (clear)="(true)"
      [placeholder]="'addLP.thirdStep.selectSubCategories' | translate"
      [ngClass]="{
        'is-invalid':
          !form.get('subCategories')?.valid &&
          form.get('subCategories')?.touched
      }"
    >
    </ng-select>
    <div
      class="invalid-feedback"
      *ngIf="
        !form.get('subCategories')?.valid &&
        form.get('subCategories')?.touched
      "
    >
      {{ "validation.subCategories" | translate }}
    </div>
  </div>
  <div class="form-group">
    <label class="label">{{ "addLP.thirdStep.tags" | translate }}*</label>
    <ng-select
      formControlName="tags"
      [items]="allTagNames$ | async"
      bindLabel="tags"
      bindValue="id"
      [multiple]="true"
      (clear)="(true)"
      [placeholder]="'addLP.thirdStep.selectTags' | translate"
      [ngClass]="{
        'is-invalid':
          !form.get('tags')?.valid &&
          form.get('tags')?.touched
      }"
    >
    </ng-select>
    <div
      class="invalid-feedback"
      *ngIf="
        !form.get('tags')?.valid &&
        form.get('tags')?.touched
      "
    >
      {{ "validation.tags" | translate }}
    </div>
  </div>
</form>
